import { IndexableDocument } from "hooks/queries/useDocuments";
import { axiosBeyonClient } from "utils/beyonAuth/beyonAxiosClient";
import { useMutation } from "@tanstack/react-query";
import { UploadFile } from "pages/Uploader";
import { Dictionary } from "types";
import { WorkspaceConfig } from "types/WorkspaceConfig";

export type BatchDocumentInsertProps = {
    onSuccess?: () => void,
    onCancel?: () => void,
    files: Dictionary<UploadFile>
}

type BatchRequest = {
    method: string;
    url: string;
    body: Record<string, any>;
};

export function useBatch<TResponse>(workspaceConfig?: WorkspaceConfig) {

    return useMutation({
        mutationFn: async (requests: BatchRequest[]) => {

            // Send the batch request    
            const response = await axiosBeyonClient.post<BatchResponse<TResponse>>(
                `${workspaceConfig?.connectorConfig?.apiEndpoint}/$batch`,
                {
                    requests: requests.map((request) => ({
                        ...request,
                        headers: {
                            "Content-Type": "application/json",
                        }
                    }))
                },
            );

            return response.data;
        }
    });

}


export type BatchResponse<T> = {
    responses: {
        id: string,
        status: number,
        headers: Record<string, string>,
        body: T
    }[]
}